import React, { useState, useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { View, Text, Pressable } from 'react-native';
import styled from 'styled-components/native';
import Input from '../../../elements/inputs';
import Modal from '../../../elements/Modal';
import { useMutation, useQuery } from '@apollo/client';
import { SETTING, UPDATE_SETTING } from '../../Settings/queries';
import {
  MainContainer,
  ContentContainer,
  TableContainer,
  PageTitle,
  LinkContainer,
  SubNavContainer,
  TableNavbarContainer,
  LinkSpace
} from '../../../elements';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';


const RequestPurchaseOrderNumber = (props) => {
  const [submitting, setSubmitting] = useState();
  const [showRequestNewPON, setShowRequestNewPON] = useState();
  const [lastPurchaseOrderNumber, setLastPurchaseOrderNumber] = useState();

  const { loading, error, data, refetch } = useQuery(
    SETTING, { variables: {} }
  );
  const [updateSetting] = useMutation(UPDATE_SETTING, {
    onCompleted: (response) => {
      refetch();
      setLastPurchaseOrderNumber(
        response?.updateSetting?.setting?.lastPurchaseOrderNumber
      );
      setShowRequestNewPON(false);
    }
  });

  const onSubmit = useCallback(input => {
    // if(window.confirm('Get new Purchase Order Number?')) {
      setSubmitting(true);
      input['lastPurchaseOrderNumber'] = parseInt(input['lastPurchaseOrderNumber']);
      updateSetting({ variables: input });
    // }
  });

  const { control, handleSubmit, reset, setValue, getValues,
      formState: { errors } } = useForm({
    defaultValues: {
      lastPurchaseOrderNumber: ''
    }
  });

  useEffect(() => {
    if(data !== undefined) {
      reset({
        lastPurchaseOrderNumber: data?.settings?.lastPurchaseOrderNumber
      })
      setLastPurchaseOrderNumber(data?.settings?.lastPurchaseOrderNumber);
    }
  }, [data])

  return (
    <View>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '150%',
          marginLeft: '-10%'
        }}
      >
        <Text>Current Purchase Order Number:</Text>
        <span>
          <Text style={{fontWeight: 'bold', marginLeft: '10px'}}>
            {lastPurchaseOrderNumber}
          </Text>
        </span>
        <LinkSpace />
        <Pressable
          onPress={() => setShowRequestNewPON(true)}
        >
          <Text>Request New PO Number</Text>
        </Pressable>
        {showRequestNewPON &&
          <Modal
            showModal={showRequestNewPON}
            setShowModal={setShowRequestNewPON}
            modalType={'Request New Purchase Order Number'}
          >
            <Input.Text
              label="New Purchase Number:"
              name="lastPurchaseOrderNumber"
              control={control}
              errors={errors}
            />
            <ButtonContainer>
              <ButtonGroup>
                <Button
                  label="Set New Purchase Order Number"
                  onPress={handleSubmit(onSubmit)}
                  style={{width: 'fit-content'}}
                />
              </ButtonGroup>
            </ButtonContainer>
          </Modal>
        }
      </View>
    </View>
  )
}

export default RequestPurchaseOrderNumber;